import { bool, string, number, func, shape } from 'prop-types';
import React, { Fragment } from 'react';
import classnames from 'classnames';
import { productShape } from 'shapes';
import { Swipe, Image } from 'components';
import { withFeatureFlags } from 'connectors';
import './ProductCardPicture.scss';

function ProductCardPicture({
    product,
    lazyload,
    thumbnailCurrentImage,
    activePosition,
    onSwipeLeft,
    onSwipeRight,
    isSalesPeriod,
    paintExperience,
    className,
    cdn,
    platform,
}) {
    const rootClassnames = classnames('product-card__picture', {
        [className]: !!className,
    });
    const iconClassnames = classnames(
        'icon',
        'icon__sale',
        'icon__sale--listing',
        `icon__sale--${platform.PLATFORM.toLowerCase()}`,
    );

    return (
        <div className={rootClassnames}>
            <div className="product-card-content__img-container">
                <Image
                    alt=""
                    className="image product-card-content__img"
                    src={thumbnailCurrentImage}
                    lazyload={lazyload}
                    cdn={cdn}
                />
                {isSalesPeriod && product.on_sale ? (
                    <i className={iconClassnames} />
                ) : null}
            </div>
            {paintExperience && product.has_sample && (
                <p className="product-card-model">Testeurs disponibles</p>
            )}

            {product.thumbnails && product.thumbnails.length > 1 && (
                <Fragment>
                    <Swipe.SwapDots
                        wrapperClassName="image-product-swipe__points"
                        className="image-product-swipe__point"
                        activePosition={activePosition}
                        iterationTab={product.thumbnails}
                    />
                    <Swipe.Controls
                        onPrevClick={onSwipeRight}
                        onNextClick={onSwipeLeft}
                        className="image-product-swipe__controls"
                    />
                </Fragment>
            )}
        </div>
    );
}

ProductCardPicture.propTypes = {
    className: string,
    product: productShape.isRequired,
    lazyload: bool.isRequired,
    thumbnailCurrentImage: string,
    activePosition: number,
    onSwipeLeft: func,
    onSwipeRight: func,
    isSalesPeriod: bool,
    paintExperience: bool,
    cdn: shape({
        CDN_IMAGE: string,
    }).isRequired,
    platform: shape({
        platform: string,
    }).isRequired,
};

ProductCardPicture.defaultProps = {
    className: null,
    onSwipeLeft: null,
    onSwipeRight: null,
    thumbnailCurrentImage: '',
    activePosition: 0,
    paintExperience: false,
    isSalesPeriod: false,
};

export default withFeatureFlags({
    mobileWidth: 'instantSearch.old.mobileWidth',
})(ProductCardPicture);
